/* cart-drawer-extras.js
 * Re-initialise Shopify's dynamic (accelerated) checkout buttons inside the cart
 * drawer. The drawer's inner HTML is replaced on every cart change
 * (CartDrawer.renderContents -> innerHTML), which destroys the
 * .shopify-payment-button container that Shopify's payment-button script
 * initialised at page load. Shopify.PaymentButton.init() re-scans the DOM and
 * initialises any uninitialised buttons. We debounce + observe the drawer so the
 * wallet buttons reappear after every add/remove/quantity change.
 */
(function () {
  var timer;

  function initPaymentButtons() {
    if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
      try { Shopify.PaymentButton.init(); } catch (e) { /* noop */ }
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(initPaymentButtons, 150);
  }

  function setup() {
    var drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (!drawer) return;

    // initial pass (covers the first render)
    schedule();

    // re-init whenever the drawer subtree changes AND a payment-button container
    // is present. Debounced to avoid loops, since init() repopulating the
    // container would otherwise re-trigger the observer.
    var observer = new MutationObserver(function () {
      if (drawer.querySelector('.shopify-payment-button')) schedule();
    });
    observer.observe(drawer, { childList: true, subtree: true });

    // also re-init when the drawer is opened (class/attribute toggle)
    var openObserver = new MutationObserver(function () { schedule(); });
    openObserver.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
  }

  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', setup);
})();
